module.exports = __webpack_public_path__ + "img/ghana.093b34e9.svg";